export default __webpack_public_path__ + "static/media/mana11.1ff0c4df.svg";